import React from 'react';
import './Loader.css';
import logo from '../img/logonew.jpg';

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <div className="loader-content">
        <div className="loader-logo-container">
          <img src={logo} alt="Swiftkey Development" className="loader-logo" />
          <div className="loader-ring"></div>
          <div className="loader-ring-2"></div>
        </div>
        <div className="loader-text">
          <h3>Swiftkey Development Ltd</h3>
          <p>Loading your hospitality solutions...</p>
        </div>
        <div className="loader-bar">
          <div className="loader-progress"></div>
        </div>
      </div>
    </div>
  );
};

export default Loader;
